import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import isoCountries from "i18n-iso-countries";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import AutocompleteComponent from "../../components/CustomInputs/AutocompleteComponent";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SelfRegistrationCustomPhone from "../OnBoardV2/SelfRegistrationCustomPhone";

export default function WatchlistFilterForm(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [purposeData, setPurposeData] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  // const country = props.country
  const [country, setCountry] = useState("");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [payload, setPayload] = useState({
    email: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    visitorCompanyName: "",
    contactEmail: "",
    contactPhoneNumber: "",
    purposeTypeId: "",
  });

  const handleClose = () => {
    setPayload({
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      visitorCompanyName: "",
      contactEmail: "",
      contactPhoneNumber: "",
      purposeTypeId: "",
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    email: false,
    phoneNumber: false,
    firstName: false,
    lastName: false,
    visitorCompanyName: false,
    purposeTypeId: false,
    contactEmail: false,
    contactPhoneNumber: false,
  });

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPayload({
      ...payload,
      phoneNumber: value.toString().replace(data.dialCode, ""),
    });
  };

  const handleContactPhoneChange = (value, data, event, formattedValue) => {
    setPayload({
      ...payload,
      contactPhoneNumber: value.toString().replace(data.dialCode, ""),
    });
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const handleSubmit = () => {
    if (
      payload.firstName.trim() === "" &&
      payload.lastName.trim() === "" &&
      payload.email.trim() === "" &&
      payload.phoneNumber.trim() === "" &&
      payload.contactEmail.trim() === "" &&
      payload.purposeTypeId.trim() === "" &&
      payload.contactPhoneNumber.trim() === ""
    ) {
      Toast(t("COMMON015"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      visitorCompanyName: "",
      contactEmail: "",
      contactPhoneNumber: "",
      purposeTypeId: "",
    });
    handleClose();
  };

  const loadData = () => {
    loadCompany();
    loadPurposeType();
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          }
        }
      })
      .catch((er) => { });
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event.id,
    });
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <WatchlistFilterForm />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <WatchlistFilterForm />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      <Grid item xs={6}>
        <Dialog
          open={open}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <DialogTitle
            variant="h4"
            style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
          >
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 15,
                top: 11,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon onClick={handleClose} />
            </IconButton>
            <Typography
              style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
            >
              {t("COMMON006")}
            </Typography>
          </DialogTitle>
          <Divider
            variant="middle"
            style={{
              background: darkMode
                ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
                : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
              height: "1px",
              opacity: 0.5,
            }}
          />

          <DialogContent
            style={{
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
              paddingBottom: "0px",
            }}
          >
            <Grid
              container
              rowSpacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <Grid item xs={12} sm={12}>
                <CustomTextfield
                  variant="outlined"
                  label={t("COMMON020")}
                  error={error.firstName}
                  name="firstName"
                  value={payload.firstName}
                  handleChange={(e) => handleChange(e)}
                  autoComplete="off"
                  inputProps={{ maxLength: 50 }}
                  style={{ margin: "1px" }}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <SelfRegistrationCustomPhone
                  specialLabel={t("COMMON063")}
                  country={country}
                  placeholder="Mobile *"
                  handleChange={(value, data, event, formattedValue) =>
                    handlePhoneChange(value, data, event, formattedValue)
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <CustomTextfield
                  label={t("COMMON042")}
                  name="email"
                  value={payload.email}
                  handleChange={(e) => handleChange(e)}
                  autoComplete="off"
                  inputProps={{ maxLength: 50 }}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <AutocompleteComponent
                  label="Purpose Type"
                  name="purposeTypeId"
                  error={error.purposeTypeId}
                  value={payload.purposeTypeId}
                  isOptionEqualToValue={(option, value) => option.name === value}
                  onSelect={(e) => onselectPurposeType(e)}
                  options={purposeData}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} mt={2} mb={1}>
              <Typography
                color={darkMode ? "#fff" : "#242424"}
                fontSize={"18px"}
                opacity={1}
                fontWeight={550}
              >
                {t("PERSONINFO")} {""}{" "}
              </Typography>
            </Grid>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={12} sm={12}>
                <CustomTextfield
                  label={t("WATCHLISTTEMP002")}
                  name="contactEmail"
                  value={payload.contactEmail}
                  handleChange={(e) => handleChange(e)}
                  autoComplete="off"
                  inputProps={{ maxLength: 50 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <SelfRegistrationCustomPhone
                  placeholder="Mobile *"
                  specialLabel={t("WATCHLISTTEMP009")}
                  country={country}
                  handleChange={(value, data, event, formattedValue) =>
                    handleContactPhoneChange(value, data, event, formattedValue)
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{
              justifyContent: "center",
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
            }}
          >
            <CancelButtons
              variant="contained"
              color="secondary"
              onClick={handleClose}
            >
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("Cancel")}
              </Typography>
            </CancelButtons>
            <SubmitButtons variant="contained" onClick={handleSubmit}>
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON024")}
              </Typography>
            </SubmitButtons>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
